<template> 
    <div @click="opentabfromlayout" class="w3-bar w3-theme-l3 w3-round-large"><slot></slot></div>    
    
</template>

<script>
  
  export default {
    props:["show"],
    methods: {      
      opentabfromlayout(event) {  
        // console.log(event.currentTarget)
        // console.log(event.target)
        // console.log(event)
        // console.log(event.srcElement.attributes['tab'].value)
        let tab = `${event.target.id}_tab`        
        if(event.srcElement.attributes['tab'])
            tab = event.srcElement.attributes['tab'].value        

        let i;        
        let tabs_display = document.getElementsByClassName("tabs_display");
        for (i = 0; i < tabs_display.length; i++) {
            tabs_display[i].style.display = "none";  
        }    

        let tablinks = document.getElementsByClassName("tablink");
        for (i = 0; i < tablinks.length; i++) {
            tablinks[i].className = tablinks[i].className.replace(" w3-red", "");
        } 
        
        document.getElementById(tab).style.display = "block";  
        event.target.className += " w3-red";

      }
    }, 
    mounted: function () {      
      if(this.show)
        {
            let tablink = document.getElementById(`${this.show}`)
            tablink.className += " w3-red";                        
            let displaytab = tablink.attributes['tab']?tablink.attributes['tab'].value:`${this.show}_tab`        
            document.getElementById(displaytab).style.display = "block";              
        }
    }
  };
</script>

<style>
    .tabs_display{
    padding-top: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/shared/controls/layouts/TabLinkLayout.vue